import { HintsTabComponent } from './components/hints-tab/hints-tab.component';
import { LogsComponent } from 'shared/logs/logs.component';
import { CommentsComponent } from 'shared/comments/comments.component';


export const rightPanelNavs: any[] = [
  {
    title: 'Hints',
    name: 'hints',
    active: true,
    component: HintsTabComponent,
  },
  {
    title: 'Comments',
    name: 'comments',
    active: false,
    component: CommentsComponent,
  }
];
